import React from 'react'
import TableData from '../Includes/Table/TableData'
import FonctionsToolbarMobile from './FonctionsToolbarMobile'
import FonctionsToolbarDesktop from './FonctionsToolbarDesktop'
import {
  useSelector
} from 'react-redux'
import {
  Paper
} from '@mui/material'
import {
  properties
} from '../../Settings/Fonctions'

const FonctionsContent = () => {
  const device = useSelector(state => state.device)
  const fonctions = useSelector(state => state.fonctions.fonctions)
  const maximum = useSelector(state => state.compte.maximum.fonctions)
  return (
    <>
      {
        (
          (device.mobile) &&
          (maximum !== -1) &&
          (fonctions.length < maximum)
        )
          ? <FonctionsToolbarMobile/>
          : null
      }
      <Paper>
        {
          (device.desktop)
            ? <FonctionsToolbarDesktop/>
            : null
        }
        {
          (fonctions.length > 0)
            ? <TableData
                data={fonctions}
                pagination={device.desktop}
                size={
                  (device.desktop)
                    ? "large"
                    : "small"
                }
                {...properties}
              >
                {
                  (fonctions.length === maximum)
                    ? <caption>Vous avez atteint le nombre maximum de fonctions.</caption>
                    : null
                }
              </TableData>
            : null
        }
      </Paper>
    </>
  )
}

export default FonctionsContent
